import React from "react";
import ReactDOM from "react-dom/client";
import Modal from "react-modal";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
// After Bootstrap on purpose: theme.css overrides its utilities, which are all
// built for a white page.
import "./styles/theme.css";
import App from "./App";
// Starts i18next with the panel's labels in English (see the file).
import "./i18n";

Modal.setAppElement("#root");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
